import React, {
    ChangeEvent,
    MouseEventHandler,
    useEffect,
    useState,
} from "react";
import {
    ModalContentWrapper,
    SelectDiv,
    TickerItemDiv,
    TickerName,
    TickersSelectWrapper,
    TickersTitle,
    TopElementsDiv,
} from "./styles";
import { SearchInput } from "../Inputs/inputsStyles";
import BasedModal, { IProps } from "../BaseModalComponents/BasedModal";
import ModalFooter from "../BaseModalComponents/Footer/ModalFooter";
import { useAppSelector } from "hooks/redux";
import { useDispatch } from "react-redux";
import { addTickerToGroup } from "store/reducers/GroupsSlice";
import { getTickers, removeTickerFromAddModal } from "store/reducers/TabsSlice";
import {

    // setDefaultTickerSettings,
    setSelectedTicker,
    changeTickerBlockStatus,
    resetSavedCPSettings,
    getTickerSettings,
} from "../../store/reducers/SettingsSlice";
import { getTickerParams } from "store/reducers/FilterSlice";

const scrollStyles = {
    backgroundColor: "#7CBE7B",
    width: "6px",
    borderRadius: "10px",
};
// type CloseType = Pick<IProps, "onRequestClose"> | undefined

const TickerItem = ({
    name,
    onTickerClick,
}: {
    name: string;
    onTickerClick: any;
}) => {
    const dispatch = useDispatch();
    const activeGroup = useAppSelector((state) => state.settings.activeGroup);
    const activeTicker = useAppSelector((state) => state.settings.activeTicker);
    const get_ticker_settings_error = useAppSelector(
        (state) => state.settings.error,
    );

    const handleClick: MouseEventHandler<HTMLDivElement> = () => {
        dispatch(resetSavedCPSettings());
        dispatch(
            setSelectedTicker({
                name: name,
                index: -1,
                schedule_id: "",
                isNew: true,
            }),
        );
        dispatch(getTickerSettings());
        // dispatch(setDefaultTickerSettings());
        dispatch(
            addTickerToGroup({
                name: {
                    ticker_name: name,
                    index: -1,
                    schedule_id: "",
                },
                isNew: true,
            }),
        );
        dispatch(removeTickerFromAddModal(name));
        // dispatch(getTickerParams());
        if (
            typeof activeTicker?.name === "string" &&
            activeTicker.name.length &&
            typeof get_ticker_settings_error !== "string" &&
            !activeTicker.name.includes("Название")
        ) {
            dispatch(
                changeTickerBlockStatus({
                    blockIt: false,
                    group: activeGroup.name,
                    ticker: activeTicker.name,
                }),
            ); // разблокировать тикер с которого мы ушли
        }
        // dispatch(addTicker(name))
        onTickerClick();
    };

    return (
        <TickerItemDiv onClick={handleClick}>
            <TickerName>{name}</TickerName>
        </TickerItemDiv>
    );
};
// const MemoTickersList = React.memo(TickersList)

function AddTickerModal({ isOpen, onRequestClose }: IProps) {
    const dispatch = useDispatch();
    const { addTickerPopup } = useAppSelector((state) => state.tabs);

    const { activeGroupTickers } = useAppSelector((state) => state.groups);

    const [popupTickers, setPopupTickers] = useState([] as string[]);

    const [searchString, setSearchString] = useState("");

    useEffect(() => {
        try {
            const popupTickers = addTickerPopup.filter((ticker) =>
                ticker
                    .toLocaleLowerCase()
                    .includes(searchString.toLocaleLowerCase()),
            );
            setPopupTickers(popupTickers);
        } catch (e) {
            console.error("The error occurred in AddTickerModal:", e);
        }
    }, [activeGroupTickers, addTickerPopup, searchString]);

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchString(e.target.value);
    };
    // useEffect(() => {
    //     dispatch(getTickers());
    // }, [dispatch]);
    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <ModalContentWrapper>
                <TickersSelectWrapper>
                    <TopElementsDiv>
                        <TickersTitle>Выберите тикер</TickersTitle>
                        <SearchInput
                            type="text"
                            placeholder="Поиск"
                            onChange={handleSearchChange}
                            value={searchString}
                        />
                    </TopElementsDiv>
                    <SelectDiv
                        thumbSize={60}
                        renderThumbVertical={(props: any) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    ...scrollStyles,
                                }}
                            />
                        )}
                    >
                        {popupTickers.sort().map((ticker, index) => {
                            return (
                                <TickerItem
                                    key={index}
                                    name={ticker}
                                    onTickerClick={onRequestClose}
                                />
                            );
                        })}
                    </SelectDiv>
                </TickersSelectWrapper>
                <ModalFooter
                    applyText="ОК"
                    onApplyClick={onRequestClose}
                    style={{
                        padding: "30px 15px 27px",
                    }}
                    buttonBoxStyle={{
                        justifyContent: "flex-end",
                    }}
                />
            </ModalContentWrapper>
        </BasedModal>
    );
}

export default AddTickerModal;
